import { render, staticRenderFns } from "./PfLoanTransactionWizardFront.vue?vue&type=template&id=28e88196"
import script from "./PfLoanTransactionWizardFront.vue?vue&type=script&lang=js"
export * from "./PfLoanTransactionWizardFront.vue?vue&type=script&lang=js"
import style0 from "./PfLoanTransactionWizardFront.vue?vue&type=style&index=0&id=28e88196&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports